export const SNACKBAR_VARIANTS = {
  info: 'info',
  success: 'success',
  error: 'error',
};

export const NO_AVAILABLE_DATES = 'No Kinematics Available for Base Station';
